import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.from.js";

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { uniq, compact } from 'lodash';
import { nextFrame, Defer } from '../core/utils';
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var ImagesLoaded = /*#__PURE__*/function () {
  function ImagesLoaded() {
    var _this = this;

    var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, ImagesLoaded);

    var elements = images; // passed an image source

    if (typeof images === 'string' || images.tagName) {
      elements = [images];
    } // get valid sources to load


    var sources = elements.filter(function (o) {
      if (typeof o === 'string') return true;
      if (o.tagName && o.tagName === 'IMG' && typeof o.src !== 'undefined') return true;
      return false;
    }); // get real loaded source

    sources = sources.map(function (img) {
      var src = img;

      if (img.tagName) {
        src = typeof img.currentSrc !== 'undefined' && img.currentSrc ? img.currentSrc : img.src;
      }

      return src;
    }); // properties

    this.images = uniq(sources);
    this.total = this.images.length;
    this.loaded = 0;
    this.callbacks = {
      progress: [],
      fail: [],
      then: [],
      catch: []
    }; // if any images was found

    if (this.total === 0) {
      var args = [this.loaded, this.total];
      nextFrame(function () {
        _this.callbacks.progress.forEach(function (fn) {
          return fn.apply(void 0, args);
        });

        _this.callbacks.then.forEach(function (fn) {
          return fn(_this.images);
        });
      });
      return this;
    } // check for images loading state


    var promises = [];
    this.images.forEach(function (img) {
      // eslint-disable-next-line no-undef
      var image = new Image();
      var promise = new Defer();

      var onLoad = function onLoad(e) {
        image.removeEventListener('load', onLoad);
        image.removeEventListener('error', onLoad);
        var args = [_this.loaded, _this.total, e.type === 'load'];
        _this.loaded += 1;
        promise.resolve.apply(promise, args);

        _this.callbacks.progress.forEach(function (fn) {
          return fn.apply(void 0, args);
        });

        if (e.type === 'error') {
          _this.callbacks.fail.forEach(function (fn) {
            return fn.apply(void 0, args);
          });
        }
      };

      image.addEventListener('load', onLoad);
      image.addEventListener('error', onLoad);
      promises.push(promise);
      image.src = img;
    });
    Promise.all(promises).then(function () {
      _this.callbacks.then.forEach(function (fn) {
        return fn(_this.images);
      });
    }).catch(function () {
      _this.callbacks.catch.forEach(function (fn) {
        return fn(_this.images);
      });
    });
    return this;
  }

  _createClass(ImagesLoaded, [{
    key: "progress",
    value: function progress(handler) {
      this.callbacks.progress.push(handler);
      return this;
    }
  }, {
    key: "fail",
    value: function fail(handler) {
      this.callbacks.fail.push(handler);
      return this;
    }
  }, {
    key: "then",
    value: function then(handler) {
      this.callbacks.then.push(handler);
      return this;
    }
  }, {
    key: "catch",
    value: function _catch(handler) {
      this.callbacks.catch.push(handler);
      return this;
    }
  }]);

  return ImagesLoaded;
}();
/**
 * Try to get image file source
 * @param {*} elm
 */


export { ImagesLoaded as default };

function getImageSrc(elm) {
  var preload = elm.getAttribute('data-preload');
  var style = window.getComputedStyle ? window.getComputedStyle(elm, null) : elm.currentStyle;
  var src; // if src is from an image

  if (typeof elm.src !== 'undefined') {
    src = typeof elm.currentSrc !== 'undefined' && elm.currentSrc ? elm.currentSrc : elm.src;
  } // if src is from a background image


  if (typeof preload !== 'undefined' && style.backgroundImage !== 'none') {
    src = style.backgroundImage.replace(/.*\s?url\(['"]?/, '').replace(/['"]?\).*/, '');
  } // if src is a declared string in data attribute


  if (typeof preload !== 'undefined' && preload) {
    src = preload;
  }

  return src;
}
/**
 * Find images to be loaded
 * @param {*} elements
 */


export function imagesLoaded(elements) {
  var sources = [];
  elements = elements.length ? Array.from(elements) : [elements];
  elements.forEach(function (elm) {
    var src = getImageSrc(elm);
    if (src) sources.push(src);
    elm.querySelectorAll('img, *[data-preload]').forEach(function (el) {
      var source = getImageSrc(el);
      if (source) sources.push(source);
    });
  });
  var images = compact(uniq(sources));
  return new ImagesLoaded(images);
}

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}